import { render, staticRenderFns } from "./TheReturnExchangeEdit.vue?vue&type=template&id=4a8009c4&scoped=true"
import script from "./TheReturnExchangeEdit.vue?vue&type=script&lang=js"
export * from "./TheReturnExchangeEdit.vue?vue&type=script&lang=js"
import style0 from "./TheReturnExchangeEdit.vue?vue&type=style&index=0&id=4a8009c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8009c4",
  null
  
)

export default component.exports